import { Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CardTitle from "@saleor/components/CardTitle";
import { getStaffUserType } from "@saleor/utils/smop";
import React from "react";
import { useIntl } from "react-intl";

import { getUserInitials, maybe } from "../../../misc";
import { AccountSettingDetails_user } from "../../types/AccountSettingDetails";
import { AccountSettingDetailsPageFormData } from "../AccountSettingDetailsPage";

const useStyles = makeStyles(
  theme => ({
    avatar: {
      "& svg": {
        fill: "#fff"
      },
      "&:hover $avatarHover": {
        opacity: 1
      },
      alignItems: "center",
      borderRadius: "100%",
      display: "grid",
      height: 120,
      justifyContent: "center",
      overflow: "hidden",
      position: "relative",
      width: 120
    },
    avatarActionText: {
      "&:hover": {
        textDecoration: "underline"
      },
      cursor: "pointer",
      fontSize: 12
    },
    avatarDefault: {
      "& div": {
        color: "#fff",
        fontSize: 35,
        fontWeight: "bold",
        lineHeight: "120px"
      },
      background: theme.palette.primary.main,
      height: 120,
      textAlign: "center",
      width: 120
    },
    avatarHover: {
      background: "#00000080",
      borderRadius: "100%",
      fontSize: 12,
      fontWeight: 500,
      height: 120,
      opacity: 0,
      padding: theme.spacing(2.5, 0),
      position: "absolute",
      textAlign: "center",
      textTransform: "uppercase",
      transition: "opacity 0.5s",
      width: 120
    },
    avatarImage: {
      pointerEvents: "none",
      width: "100%"
    },
    card: {
      overflow: "visible"
    },
    cardTitle: {
      "& span": {
        fontWeight: "500"
      }
    },
    label: {
      marginBottom: theme.spacing(1)
    },
    prop: {
      marginBottom: theme.spacing(2)
    },
    propGrid: {
      display: "grid",
      gridColumnGap: theme.spacing(2),
      gridRowGap: theme.spacing(1),
      gridTemplateColumns: "1fr 1fr",
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "1fr"
      }
    },
    root: {
      display: "grid",
      gridColumnGap: theme.spacing(4),
      gridTemplateColumns: "120px 1fr"
    },
    textFieldGrid: {
      display: "grid",
      gridColumnGap: theme.spacing(2),
      gridTemplateColumns: "1fr 1fr"
    },
    value: {
      fontSize: 20
    }
  }),
  { name: "SellerInfo" }
);

interface UserInformationProp {
  user: AccountSettingDetails_user;
  data: AccountSettingDetailsPageFormData;
}

export const UserInformation: React.FC<UserInformationProp> = ({
  user,
  data
}) => {
  const classes = useStyles({});
  const intl = useIntl();
  return (
    <Card>
      <CardTitle
        className={classes.cardTitle}
        title={intl.formatMessage({
          defaultMessage: "User Information",
          description: "general information"
        })}
      />
      <CardContent>
        <div className={classes.root}>
          <div>
            <div className={classes.avatar}>
              {maybe(() => user.avatar.url) ? (
                <img
                  className={classes.avatarImage}
                  src={maybe(() => user.avatar.url)}
                />
              ) : (
                <div className={classes.avatarDefault}>
                  <Typography>{getUserInitials(data)}</Typography>
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.propGrid}>
              <div>
                <Typography variant="h3" gutterBottom>
                  {getStaffUserType(user)?.description || ""}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
export default UserInformation;
